// GC106 — lectura LITERAL del evento EKH que originó el caso.
// Fuente ÚNICA: `ekh_evento` persistido en el caso (heart_rate_evento / respiratory_rate_evento).
// Nunca una lectura actual posterior. El cero se conserva como literal, sin interpretarlo.
export function lecturaEkhEvento(a) {
  const ev = a?.ekh_evento;
  if (!ev) return null;
  const esResp = a.tipo === "excepcion_frecuencia_respiratoria";
  const valor = esResp ? ev.respiratory_rate_evento : ev.heart_rate_evento;
  const unidad = esResp ? "rpm" : "lpm";
  const presente = Number.isFinite(valor);
  return {
    presente,
    valor: presente ? valor : null,
    unidad,
    esResp,
    horaEvento: ev.evento_en || null,
    texto: presente ? `${valor} ${unidad}` : "Valor no incluido en el evento",
  };
}
